import './style.less'
import ServiceModalCtrl from '../service/ctrl'
import ProductModalCtrl from '../product/ctrl'

export default class SolutionModalCtrl {
  constructor (close, ModalService, id, $rootScope, $scope, selected, $sce) {

    this.selected = selected
    this.id = id
    this.ModalService = ModalService
    this.close = close
    this.solution = $rootScope.solutions.find((el) => {return el.id == id})
    this.products = $rootScope.products.filter((el) => {
      return el.solutions.find((item) => {return item == id})
    })

    this.services = $rootScope.services.filter((el) => {
      return el.solutions.find((item) => {return item == id})
    })

    $scope.$on('close', () => {
      close()
    })

    $scope.trustHtml = function (html) {
      return $sce.trustAsHtml(html)
    }
  }

  close () {
    this.close()
  }

  openProduct (id) {
    let products = this.products

    this.ModalService.showModal({
      template: require('../product/view.html'),
      controller: ProductModalCtrl,
      controllerAs: 'modal',
      inputs: {
        id: id,
        products: products
      },
      appendElement: angular.element(document.querySelector('#app-wrapper'))
    })
  }

  openService(id) {
    let services = this.services;
    this.ModalService.showModal({
      template: require('../service/view.html'),
      controller: ServiceModalCtrl,
      controllerAs: 'modal',
      inputs: {
        id: id,
        services: services
      },
      appendElement: angular.element(document.querySelector('#app-wrapper'))
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/modals/solution/ctrl.js